// import hashUtil from 'hash-index';

// import crypt from 'crypto';
import md5 from 'md5';

// const createHash = (input: string): string => {
//   const hashedValue: string = crypt
//     .createHash('sha1')
//     .update(input)
//     .digest('hex');
//   // return hashedValue.toString();
//   return '';
// };

export const getHashStr = (input: string): string => {
  return md5(input);
};

// const getHashNum = (input: string): number => {
//   return 0;
// };

export const customEncodeStr = (input: string): string => {
  return encodeURIComponent(input.toLowerCase()).replace('.', '');
};
